import React, { useEffect } from 'react';
import { withWrapper } from '@shared/react';
import {
    MyPortfolioTableProvider,
    useClientDetailsTable,
    getTransactionsTableColumns,
    UserManagement_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import './MyPortfolioTable.scss';
import { Loader } from '@shared/UI';

interface MyPortfolioTableContentProps {
    accountId: number;
}

const MyPortfolioTableContent: React.FC<MyPortfolioTableContentProps> = ({ accountId }) => {
    const { AssignPositionBody, paginationOptions, setAccountId, portfolioLoading } = useClientDetailsTable();

    useEffect(() => {
        if (accountId === 0 || accountId) {
            setAccountId(accountId);
        }
    }, [accountId, setAccountId]);

    if (portfolioLoading) {
        return <Loader />;
    }

    return (
        <Table
            columns={getTransactionsTableColumns()}
            data={AssignPositionBody}
            tableTitle={undefined}
            infoLink={UserManagement_TABLE_INFO_URL}
            paginationOptions={paginationOptions}
            filters={undefined}
            row={undefined}
            noScroll={true}
            noBorderTable={true}
        />
    );
};

export const MyPortfolioTable = withWrapper(MyPortfolioTableProvider)(MyPortfolioTableContent);
